import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInactiveCarrierReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCa: ExcludableTextbox;
    excludabletextboxCarrierManagers: ExcludableTextbox;
    excludabletextboxS: ExcludableTextbox;
    sourceInactiveCarrier: DataSource;
    textboxDaysSince: Textbox;
    textboxGroupBy: Textbox;
}
